import { render, staticRenderFns } from "./orgSuggest.vue?vue&type=template&id=06bc26a7&"
import script from "./orgSuggest.vue?vue&type=script&lang=ts&"
export * from "./orgSuggest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports